<script lang="ts">
  import SkillSelfAssessment from '$lib/components/student/SkillSelfAssessment.svelte';
  import type { PageProps } from './$types';
  let { data, params }: PageProps = $props();

  const skillId = $derived(parseInt(params.skill_id));
</script>

{#await data.classPromise then leaderboard}
  {#key skillId}
    <SkillSelfAssessment
      classId={parseInt(params.id)}
      {skillId}
      lbSkill={leaderboard.skills.find(x => x.skillId === skillId)!}
    />
  {/key}
{/await}
